import type { ErrorEvent, EventHint } from "@sentry/browser";
import { AppSyncError } from "./aws/appsync/AppSyncError.js";

const dropErrorMessages = [/Signature not yet current:/u, /Signature expired:/u];

export function sentryBeforeSend(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
	const exception = hint.originalException;

	if (
		typeof exception === "object" &&
		exception &&
		"message" in exception &&
		dropErrorMessages.some((message) => message.test(String(exception.message)))
	) {
		return null;
	}

	if (exception instanceof AppSyncError) {
		event.fingerprint = ["{{ default }}", String(exception.name), String(exception.message)];
	}

	return event;
}
